import React from 'react';

function Message(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M12.0584 3.37501C15.6895 3.36863 18.9284 5.65804 20.1369 9.08448C21.3455 12.5111 20.2603 16.3283 17.4297 18.6047C14.6893 20.8085 10.8919 21.1028 7.85471 19.3777L3.269 21.5642C3.03015 21.678 2.74546 21.6292 2.55827 21.4421C2.37108 21.2551 2.32195 20.9705 2.43562 20.7315L4.61974 16.1402C3.15292 13.554 3.13186 10.3795 4.58462 7.76636C6.09347 5.05232 8.95477 3.37091 12.0584 3.37501ZM18.9581 9.50026C17.9258 6.57366 15.1597 4.6192 12.0597 4.62501L12.0576 4.62501C9.40847 4.62119 6.96551 6.05627 5.67714 8.37373C4.38872 10.6913 4.458 13.5261 5.85806 15.7778C5.97046 15.9585 5.98313 16.1841 5.89169 16.3763L4.32118 19.6777L7.61809 18.1057C7.81051 18.014 8.03643 18.0266 8.2174 18.1393C10.8499 19.7782 14.2295 19.5743 16.6463 17.6306C19.0633 15.6869 19.9904 12.427 18.9581 9.50026Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M7.7535 11.9333C7.7535 11.4322 8.15954 11.025 8.66158 11.025C9.16363 11.025 9.56966 11.4322 9.56966 11.9333C9.56966 12.4345 9.16363 12.8417 8.66158 12.8417C8.15953 12.8417 7.7535 12.4345 7.7535 11.9333Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M11.1504 11.9333C11.1504 11.4322 11.5565 11.025 12.0585 11.025C12.5606 11.025 12.9666 11.4322 12.9666 11.9333C12.9666 12.4345 12.5606 12.8417 12.0585 12.8417C11.5565 12.8417 11.1504 12.4345 11.1504 11.9333Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M14.5474 11.9333C14.5474 11.4322 14.9534 11.025 15.4555 11.025C15.9575 11.025 16.3635 11.4322 16.3635 11.9333C16.3635 12.4345 15.9575 12.8417 15.4555 12.8417C14.9534 12.8417 14.5474 12.4345 14.5474 11.9333Z"
        fillRule="evenodd"
      />
    </svg>
  );
}
export default Message;
